<template>
  <FlotoModule>
    <template v-if="hasPermission">
      <RouterView :key="$route.fullPath" />
    </template>
  </FlotoModule>
</template>

<script>
import { PreferenceComputed } from '@state/modules/preference'
import { LicenseComputed } from '@state/modules/license'
import Intersection from 'lodash/intersection'

export default {
  name: 'CustomScopeModule',
  page() {
    return {
      title: this.$tc('custom-scope-configuration'),
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (
        vm.myAllowedModules.indexOf('admin.user.custom_scope') === -1 ||
        Intersection(
          [
            vm.$constants.REQUEST,
            vm.$constants.CHANGE,
            vm.$constants.PROBLEM,
            vm.$constants.RELEASE,
            vm.$constants.ASSET,
            vm.$constants.CMDB,
          ],
          vm.availableModulesInLicense
        ).length <= 0
      ) {
        return vm.$router.replace({ name: '404' })
      }
    })
  },
  data() {
    return {
      hasPermission: false,
    }
  },
  computed: {
    ...PreferenceComputed,
    ...LicenseComputed,
  },
  created() {
    if (this.myAllowedModules.indexOf('admin.users') === -1) {
      return this.$router.replace({ name: '404' })
    }
    this.hasPermission = true
  },
}
</script>
